// extracted by mini-css-extract-plugin
export default {"global-container":"OrganizationListView_global-container__A1Buk"};